import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import store from './store';
import router from './router';
import './registerServiceWorker'
import reactor from './reactor';

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

Vue.config.productionTip = false;

Vue.use(reactor, { store, router, });


new Vue({
  el: '#app',
  router,
  store,
  render: (h) => {
    return h(App);
  },
  vuetify,
});

